import React, { useEffect, useMemo, useState } from "react";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import { Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import { ResponseModel } from "../../model/utilModels/ResponseModel";
import { PaginatorModel } from "../../model/utilModels/PaginatorModel";
import { msgTypes } from "../../constants/msgTypes";
import { UtilService } from "../../services/shared/UtilService";
import CustomTableGrid from "../../components/basicComponent/CustomTableGrid";
import FormikControl from "../../components/basicComponent/FormikControl";
import HotelBookingHistoryDetail from "./HotelBookingHistoryDetail";
import Tooltip from "@mui/material/Tooltip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
interface RowData {
  original: {
    status: string;
    Booking_status: string;
  };
}

const tabStatusMap = ["Confirmed", "Failed"];

const HotelBookingHistory = () => {
  const [value, setValue] = useState(0);
  const [tabChange, setTabChange] = useState(false);
  const [transactions, setTransactions] = useState<ResponseModel | null>(null);
  const { showInput, showSuccess, showError } = useSweetAlert();

  const navigation = useNavigate();
  console.log("transactions", transactions?.data[0]);
  const paginatorModel: PaginatorModel = new PaginatorModel();

  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
    status: tabStatusMap[0],
  });
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setTransactions(null); // Reset data immediately to avoid flicker
    setPagination((prevState) => ({
      ...prevState,
      status: tabStatusMap[newValue],
    }));
    setTabChange(true);
  };
  useEffect(() => {
    if (tabChange) {
      fetchHotelBookingList(); // Fetch only for tab change
      setTabChange(false); // Reset tab change flag
    }
  }, [pagination.status, tabChange]); // Only dependent on tab status change

  useEffect(() => {
    if (!tabChange) {
      fetchHotelBookingList();
    }
  }, [
    pagination.pageNumber,
    pagination.pageSize,
    pagination.filter,
    pagination.orderBy,
    pagination.desc,
  ]);

  const prepareRequest = (): PaginatorModel => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    requestBody.status = pagination.status || tabStatusMap[0];
    return requestBody;
  };

  const fetchHotelBookingList = async () => {
    const requestBody = prepareRequest();
    const res = await UtilService.fetchHotelBookingList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      console.log("res", res);
      setTransactions(res);
    }
  };
  // const columns = useMemo(
  //   () => [
  //     {
  //       accessorKey: "HotelName",
  //       header: "Hotel Name",
  //       size: 80,
  //     },

  //     {
  //       accessorKey: "CheckInDate",
  //       header: "Check In Date",
  //       size: 80,
  //     },
  //     {
  //       accessorKey: "CheckOutDate",
  //       header: "Check Out Date",
  //       size: 80,
  //     },
  //     {
  //       accessorKey: "City",
  //       header: "City",
  //       size: 80,
  //     },
  //     {
  //       accessorKey: "RoomType",
  //       header: "Room Type",
  //       size: 80,
  //     },
  //     {
  //       accessorKey: "Guests",
  //       header: "Guests",
  //       size: 80,
  //     },
  //     {
  //       accessorKey: "Amount",
  //       header: "Amount",
  //       size: 80,
  //     },

  //     {
  //       accessorKey: "Booking_status",
  //       header: "Status",
  //       size: 100,
  //       Cell: ({ row }: { row: RowData }) => {
  //         const Booking_status = row.original.Booking_status;
  //         let statusStyle = {};
  //         let statusText = "";

  //         switch (Booking_status) {
  //           case "Confirmed":
  //             statusStyle = { color: "#4cae4c", fontWeight: "bold" };
  //             statusText = "✔ Confirmed";
  //             break;

  //           case "failed":
  //             statusStyle = { color: "#d32f2fc2", fontWeight: "bold" };
  //             statusText = "🚫 Failed";
  //             break;

  //           default:
  //             statusStyle = { color: "grey" };
  //             statusText = Booking_status;
  //         }

  //         return <span style={statusStyle}>{statusText}</span>;
  //       },
  //     },
  //   ],
  //   []
  // );

  const initialValues = {};
  const onSubmit = () => {
    fetchHotelBookingList();
  };

  const downloadTicket = async (id: string, passenger: any) => {
    try {
      const response = (await UtilService.downloadHotelTicket(id)) as any;
      // Create a blob link
      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link and simulate click
      const link = document.createElement("a");
      link.href = blobUrl;

      // Optional: Use Content-Disposition or fallback filename
      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
      const fileName = !!passenger
        ? `${passenger?.title} ${passenger?.first_name} ${passenger?.last_name}.pdf`
        : "ticket.pdf";
      const cleanFileName = fileName.replace(/[^\w.-]/g, " ");
      link.download = cleanFileName;

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("error while download ticket", error);
    }
  };
  const handleSendEmail = (id: string) => {
    showInput("Enter your email address", "yourname@example.com", "email").then(
      async (result) => {
        if (result.isConfirmed && result.value) {
          const payload = {
            payment_reference: id,
            email: result.value,
          };
          const res = await UtilService.sendHotelTicketViaMail(payload);
          if (res?.statusMsg === msgTypes.SUCCESS.msg) {
            showSuccess("", "Ticket sent successfully to " + result.value);
          } else {
            showError("", "Failed to send ticket. Please try again later.");
          }
        }
      }
    );
  };

  return (
    <div className=" grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header flex-wrap">
              <h3 className="card-title">Hotel Booking History</h3>
            </div>
            <div className="card card-grid min-w-full ancillary-services-card">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="icon tabs example"
                className="tabs-design"
              >
                <Tab
                  icon={<RunningWithErrorsIcon className="Processing-icon" />}
                  label="Confirmed"
                  className="remittance-tabs pending"
                  iconPosition="start"
                />

                <Tab
                  icon={<DisabledByDefaultIcon className="failed-icon" />}
                  label="Failed"
                  className="remittance-tabs failed_res failed"
                  iconPosition="start"
                />
              </Tabs>

              <div className="card-body mt-3">
                {transactions?.data?.length > 0 ? (
                  <div className="scrollable-x-auto">
                    <table className="table table-border">
                      <thead>
                        <tr>
                          <th>Hotel Name</th>
                          <th>Booking ID</th>
                          <th>Check-in Date</th>
                          <th>Check-out Date</th>
                          <th>Room</th>
                          <th>Room Type</th>
                          <th>Cancellation Policy</th>
                          <th>No of Pax</th>
                          <th>City</th>
                          <th>Download</th>
                          <th>Share</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions?.data
                          .filter((item: any) => {
                            if (value === 0) {
                              // Confirmed tab
                              return item.status === "CONFIRMED";
                            }
                            if (value === 1) {
                              // Failed tab
                              return item.status === "FAILED";
                            }
                            return true;
                          })
                          .map((item: any, index: number) => (
                            <tr key={index}>
                              <td>
                                <span
                                  className="sort"
                                  onClick={() => {
                                    navigation("/HotelBookingHistoryDetail", {
                                      state: item,
                                    });
                                  }}
                                >
                                  <Link to={"/HotelBookingHistoryDetail"}>
                                    {item.name}
                                  </Link>
                                </span>
                              </td>
                              <td>
                                <span className="sort">
                                  {item.payment_reference || "N/A"}
                                </span>
                              </td>
                              <td>
                                <span className="sort">
                                  {item.check_in_date}
                                </span>
                              </td>
                              <td>
                                <span className="sort">
                                  {item.check_out_date}
                                </span>
                              </td>
                              <td>
                                <span className="sort">
                                  {item.rooms.length || "N/A"}
                                </span>
                              </td>
                              <td>
                                <span className="sort">{item.room_type}</span>
                              </td>
                              <td>
                                {item.cancellation_policy ===
                                "Booking is Refundable" ? (
                                  <span
                                    style={{
                                      color: "#4cae4c",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ✔ Refundable
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      color: "#d32f2fc2",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Non Refundable
                                  </span>
                                )}
                              </td>
                              <td>
                                <span className="sort">
                                  {item.rooms
                                    ? item.rooms.reduce(
                                        (total: any, room: any) =>
                                          total +
                                          (room.adult_details?.length || 0) +
                                          (room.child_details?.length || 0),
                                        0
                                      )
                                    : "N/A"}
                                </span>
                              </td>
                              <td>
                                <span className="sort">
                                  {item.address_detail?.city
                                    ? item.address_detail.city
                                        .charAt(0)
                                        .toUpperCase() +
                                      item.address_detail.city
                                        .slice(1)
                                        .toLowerCase()
                                    : "N/A"}
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    downloadTicket(
                                      item.payment_reference,
                                      item?.reservation_info
                                    );
                                  }}
                                >
                                  <i className="fa-solid fa-download"></i>{" "}
                                  Download
                                </button>
                              </td>
                              <td>
                                <Tooltip
                                  title={
                                    <>
                                      <div className="flex items-center gap-2 ">
                                        <WhatsAppIcon fontSize="small" />
                                        <span className="text-decoration-underline cursor-pointer">
                                          WhatsApp
                                        </span>
                                      </div>
                                      <div
                                        className="flex items-center gap-2  "
                                        onClick={() => {
                                          handleSendEmail(
                                            item.payment_reference
                                          );
                                        }}
                                      >
                                        <MailOutlineIcon fontSize="small" />
                                        <span className="text-decoration-underline cursor-pointer">
                                          Mail
                                        </span>
                                      </div>
                                    </>
                                  }
                                >
                                  <button className="btn btn-primary btn-sm">
                                    <i className="fa-solid fa-share"></i> Share
                                  </button>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p style={{ padding: "1rem", color: "gray" }}>
                    No booking records found.
                  </p>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HotelBookingHistory;
